import http from './';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const fetchDariaftha = async (fltr) => {
    try {
        const token = await AsyncStorage.getItem('token');

        var datas = JSON.stringify({ hesab: fltr.hesab });
        const headers = {
            'x-auth': JSON.parse(token),
            'Content-Type': 'application/json',
        };
        try {
            const { data } = await http.post(`${http.url2}/bardashtha`, datas, {
                headers: headers,
            });
            return data.Data;
        } catch (err) {
            return [];
        }
    } catch (err) {
        console.log(err);
    }
};
